import React from 'react'

import { usePlanCardInfo } from '../hooks/planCardInfo'
import { PlanFeatureMap } from '../Common'
import PlanButton from '../PlanButton'
import { isStandardProduct } from '../planDisplayContent'

import PlanCardTemplate from './PlanCardTemplate'

import type { TUsePlanProductList } from '@/contexts/PlanContext/hooks/planProductList'

import { EPaidProductType } from '@/contexts/PlanContext/type'
import { useProductText } from '@/contexts/PlanContext/hooks/productText'


import { useMemo } from 'react';
import { tw } from 'tagged-classnames-free';
export interface IPlanCardProps {
  className?: string
  productInfo: TUsePlanProductList['allProductsList'][number]
}

const PlanCard: React.FC<IPlanCardProps> = (props) => {
  const { className, productInfo } = props

  const { type } = productInfo
  const resolvedProductInfo = useMemo(() => {
    if (type !== EPaidProductType.BASIC) {
      return productInfo
    }

    // 默认版 BASIC 卡优先展示名称里带 standard 的 SKU；
    // 只有该桶里没有 standard 商品时，才退回展示整个 BASIC 桶。
    const standardCreditsProducts = productInfo.creditsProducts.filter(
      (product) => isStandardProduct(product),
    )

    if (!standardCreditsProducts.length) {
      return productInfo
    }

    return {
      ...productInfo,
      creditsProducts: standardCreditsProducts,
    }
  }, [productInfo, type])

  const {
    priceMonthText,
    priceSuffixText,
    appName,
    payStepInfo,
    selectedCreditsPackage,
    productName,
    isActiveDuration,
  } = usePlanCardInfo({ productInfo: resolvedProductInfo })

  const productTextInfo = useProductText({
    product: selectedCreditsPackage,
    PlanFeatureMap,
  })

  return (
    <PlanCardTemplate
      className={tw`
        ${!isActiveDuration && 'hidden'}
        ${className}
      `}
      priceMonthText={priceMonthText}
      priceSuffixText={priceSuffixText}
      productTextInfo={productTextInfo}
      productType={type}
      productName={productName}
      BuyButton={
        <PlanButton
          appName={appName}
          type={type}
          payStepInfo={payStepInfo}
          productPriceCredits={selectedCreditsPackage}
          className='rounded-lg'
        />
      }
    />
  )
}

export default PlanCard
